import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

export const getCurrentDateString = () => new Date(Date.now()).toISOString();

// Define a type for the slice state

export type IInvestData = {
  part: number;
  profit: number;
  investment: number;
  return: number;
  left: number;
  revenue: number;
};

interface ExpenseState {
  date: string;
  total: IInvestData;
}

// Define the initial state using that type
export const initialState: ExpenseState = {
  date: "",
  total: {
    part: 0,
    profit: 0,
    investment: 0,
    return: 0,
    left: 0,
    revenue: 0,
  },
};

export const expenseSlice = createSlice({
  name: "expense",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setDate: (state, action: PayloadAction<string>) => {
      state.date = action.payload;
    },

    resetTotal: (state) => {
      state.total = initialState.total;
    },

    setTotal: (state, action: PayloadAction<IInvestData>) => {
      state.total = action.payload;
    },

    addTotal: (state, action: PayloadAction<IInvestData>) => {
      state.total.part += action.payload.part;
      state.total.profit += action.payload.profit;
      state.total.investment += action.payload.investment;
      state.total.return += action.payload.return;
      state.total.left += action.payload.left;
      state.total.revenue += action.payload.revenue;
    },
  },
});

export const { setDate, resetTotal, setTotal, addTotal } = expenseSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getDate = (state: RootState) => state.expense.date;
export const getTotal = (state: RootState) => state.expense.total;

export default expenseSlice.reducer;
